module.exports = __webpack_public_path__ + "static/media/exposicions.ef7da0dc.jpg";